/**
 * Profiling JS controller.
 *
 * This class handles profiling counter calculations.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Profiling. This gets mapped with the keyword Profiling and its
 * docready method is fired automatically on pages where there's a
 * class called 'Profiling' on the html tag.
 */
class Profiling {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        this.profilingDataFound      = false;
        this.$profilingDataContainer = $( '#profiling' );
        this.localStorageProfiling   = localStorage.getItem( 'profiling' );

        if ( ! Theme.Common.empty( this.$profilingDataContainer ) ) {
            this.profilingDataFound   = true;
            this.siteProfileString    = this.$profilingDataContainer.attr( 'data-site-profiles' );
            this.currentProfileString = this.$profilingDataContainer.attr( 'data-current-profiles' );
        }

        this.profiling = {
            formattedProfiles: {},
            activeProfile: 'default',
            siteProfileString: null
        };
    }

    /**
     * This checks for an allowing setting from localstorage
     * and if it's not found, the calculate method gets called.
     */
    allowCalculate() {

        const localStorageprofilingDisabled = localStorage.getItem( 'disableProfiling' );

        if ( localStorageprofilingDisabled != 1 ) {

            if ( this.profilingDataFound ) {

                this.calculate();
            }
        }

    }

    /**
     * This calculates the profile counters and
     * sets an active profile based on the counters.
     *
     * This only gets called if profiling is not disabled by the user.
     */
    calculate() {

        let siteProfileString = null;

        if ( ! Theme.Common.empty( this.localStorageProfiling ) ) {

            // If there is already profiling data in localStorage, use it.
            this.localStorageProfiling       = JSON.parse( this.localStorageProfiling );
            this.profiling.formattedProfiles = this.localStorageProfiling.formattedProfiles;
            siteProfileString                = this.localStorageProfiling.siteProfileString;

        } else {

            // Else get initial site profile data from the profiling data HTML element.
            siteProfileString = this.siteProfileString;
            this.siteProfiles = siteProfileString.split( ',' );
            this.siteProfiles.forEach( ( siteProfile ) => {
                this.profiling.formattedProfiles[ siteProfile ] = 0;
            });
        }

        // This parses the string data attribute to a processable array.
        this.currentProfiles = this.currentProfileString.split( ',' );

        // Add each profile counters by one if corresponding current page profile IDs are
        // found in the site profile array.
        this.currentProfiles.forEach( ( currentProfile ) => {
            if ( this.profiling.formattedProfiles.hasOwnProperty( currentProfile ) ) {
                this.profiling.formattedProfiles[ currentProfile ]++;
            }
        });

        // This returns the most visited profile.
        const currentActive = _.maxBy( Object.entries( this.profiling.formattedProfiles ), ( profile ) => {
            return profile[1];
        });

        // Set active profile if the most visited profile has 3 or more visits.
        if ( ! Theme.Common.empty( currentActive ) && currentActive[1] > 2 ) {
            this.profiling.activeProfile = currentActive[0];
        }

        // Set everything back to localstorage.
        this.profiling.siteProfileString = siteProfileString;
        localStorage.setItem( 'profiling', JSON.stringify( this.profiling ) );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.allowCalculate();
    }
}

// Export the class reference.
module.exports = Profiling;



// WEBPACK FOOTER //
// ./assets/scripts/profiling.js